import { EntrySubmission } from "@/components/EntrySubmission";
import { EntryFeed } from "@/components/EntryFeed";
import { StreakDisplay } from "@/components/StreakDisplay";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { MobileNavigation } from "@/components/MobileNavigation";
import { DesktopNavigation } from "@/components/DesktopNavigation";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (!session || error) {
        localStorage.clear();
        navigate("/login");
      }
    };
    
    checkAuth();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        localStorage.clear();
        navigate("/login");
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 pb-20 md:pb-0">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">SuperBody AI</h1>
          <DesktopNavigation />
        </div>
        <StreakDisplay />
        <EntrySubmission />
        <EntryFeed />
      </div>
      <MobileNavigation />
    </div>
  );
};

export default Home;